/**
 * description: 历史签约记录
 * author: bql
 * 2023/7/20 10:29
 */

import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class SignContractRecordsApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'sign-contract-records'
    }

}